module.exports = __webpack_public_path__ + "static/img/liyade8.c719e263.jpg";